/* eslint-disable*/
import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Backdrop from "@mui/material/Backdrop";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import CheckIcon from "@mui/icons-material/Check";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { Box, Button, CircularProgress, Container } from "@mui/material";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import {
  AccountAPI,
  PerformanceBondAPI,
  RequestFormAPI,
  SharePointFolder,
} from "../services/apigateway";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import RequiredUploadDocuments from "../components/PerformanceBond/RequiredUploadDocuments";
import dayjs from "dayjs";
import helper from "../services/helper";
import { useLocation } from "react-router-dom";
import ModalPerformanceBondForm from "../components/PerformanceBond/Modal/ModalPerformanceBondForm";
import ApprovalStatus from "../components/PerformanceBond/ApprovalStatus";

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 50,
  height: 50,
  display: "flex",
  borderRadius: "50%",
  fontWeight: "bold",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundImage:
      "linear-gradient(0deg, rgba(184,0,200,1) 0%, rgba(161,0,175,1) 43%, rgba(184,0,200,1) 100%);",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    backgroundImage:
      "linear-gradient(0deg, rgba(184,0,200,1) 0%, rgba(161,0,175,1) 43%, rgba(184,0,200,1) 100%);",
  }),
}));

function ColorlibStepIcon(props) {
  let { completed } = props;

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed }}
      style={{
        color: "white",
        backgroundColor: "rgba(184,0,200,1)",
        border: "1px solid #b5b5b5",
      }}
    >
      {completed ? <CheckIcon /> : <>{props.icon}</>}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};

export default function PerformanceBondViewScreen() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = React.useState(false);
  const [objChangeMasterFile, setObjChangeMasterFile] = React.useState({});
  const [isEdited, setIsEdited] = React.useState(false);
  const [openModalComplete, setOpenModalComplete] = React.useState(false);

  const [selectedOther, setSelectedOther] = React.useState([]);
  const [pathsSharePoint, setPathsSharePoint] = React.useState([]);

  const [formId, setFormId] = React.useState([]);
  const [formHeader, setFormHeader] = React.useState([]);
  const [formItems, setFormItems] = React.useState(null);
  const [financialInfo, setFinancialInfo] = React.useState([]);
  const [disalbedForm, setDisabledForm] = React.useState(false);
  const [defaultPerformanceBond, setDefaultPerformanceBond] = React.useState(false);

  

  React.useEffect(() => {
    setDisabledForm(location && location.state?.status === "New" ? true : false);
    setFormItems(null);
    setOpenModalComplete(false);
    const element = document.querySelector(".MuiStepLabel-iconContainer");
    if (element) {
      const elementText = document.querySelector(".css-1am1g1a");
      if (elementText) {
        elementText.textContent = "3";
      }
    }

    // Call your RequestForm function here
    const fetchData = async () => {
      try {
        setLoading(true);

        if (id) {
          const accountMenu = helper.Auth.getAccountMenu();
          const accountInfo = await AccountAPI.findAll();

          const requestData = await RequestFormAPI.getById(id);
          const findAccount = accountInfo.find(
            (item) => item.CustomerId === accountMenu.accountFinancialInfo[0].AccountId
          );

          let perfBoneExiting = accountMenu.accountFinancialInfo.find(
            (item) => item.AccountId === accountInfo[0].CustomerId
          );
          setDefaultPerformanceBond(perfBoneExiting?.PerformanceBond__c)

          setFinancialInfo(findAccount);
          setFormHeader(findAccount || null);
          setFormItems(requestData?.RequestItems[0] || null);

          const response = await SharePointFolder.getPathByAccount(
            accountMenu.accountFinancialInfo[0].AccountId || ""
          );

          const filesSharePoint = response.responseData;
          const mappedFiles = {
            Account_Common_CTR_Others: [],
          };
          filesSharePoint.forEach((folder) => {
            if (mappedFiles.hasOwnProperty(folder.Name)) {
              mappedFiles[folder.Name] = folder.Path || [];
            }
          });
          setPathsSharePoint(mappedFiles);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    window.scrollTo({ top: 0, behavior: "smooth" });
    fetchData();
  }, [id]);

  const uploadFileToSharepoint = async (file, namefolder) => {
    const accountMenu = helper.Auth.getAccountMenu();

    try {
      if (file && namefolder) {
        const uploadResponse = await SharePointFolder.uploadFile(
          namefolder,
          [file],
          accountMenu.accountFinancialInfo[0].AccountId || ""
        );
        console.log("Upload SP financial res:", uploadResponse);
      }
    } catch (error) {
      console.error("Error while uploading:", error);
      if (error.response) {
        console.error("Response:", error.response);
      }
      Swal.fire({
        title: "Error while uploading:" + error,
        icon: "error",
        position: "center",
      });
    }
  };

  const updateFiles = async () => {
    try {
      const userInfo = helper.Auth.getTokenData();
      const accountMenu = helper.Auth.getAccountMenu();

      const fileInputs = [
        { id: "FileOther2", path: pathsSharePoint.Account_Common_CTR_Others },
      ];

      // Function to rename and upload files
      const processFiles = async (fileInput) => {
        const fileElement = document.getElementById(fileInput.id);

        if (!fileElement || fileElement.files.length === 0) return [];

        const uploads = Array.from(fileElement.files).map(async (file) => {
          const timestamp = dayjs().format("YYYYMMDD_HHmmss");
          const renamedFile = new File(
            [file],
            `${file.name.replace(/\.[^/.]+$/, "")}_${timestamp}.${file.name
              .split(".")
              .pop()}`,
            { type: file.type }
          );
          await uploadFileToSharepoint(renamedFile, fileInput.path);
          return {
            name: renamedFile.name,
            type: fileInput.path.split(".").pop(),
          };
        });

        return Promise.all(uploads);
      };

      // Process all file inputs and Upload summary to Salesforce ##__ChangeMasterFiles__##
      const allFilesExist = await checkFilesExist();

      const masterFileList = (
        await Promise.all(fileInputs.map(processFiles))
      ).flat();

      if (formItems) {
        formHeader.CTRUser = userInfo.id;
        formHeader.PerformanceBondHeader = financialInfo?.PerformanceBond || "";
        formHeader.PerformanceBondItem =
          objChangeMasterFile?.RequestFormItem.PerformanceBond || "";
        formHeader.Remark = objChangeMasterFile?.RequestFormItem.Remark || "";
        formHeader.AccountId = accountMenu.accountFinancialInfo[0].AccountId || "";
        formHeader.FinancialInformationId =
          accountMenu.accountFinancialInfo[0].Id || "";
        formHeader.RequestItemId = formItems.Id || null;

        let resPerfomance = await PerformanceBondAPI.submitRequestForm(
          formHeader
        );

        console.log("response create perfomance bond :: ", resPerfomance);
        setFormId(resPerfomance && resPerfomance.RegistrationNumber);

        return true;
      } else {
        if (allFilesExist) {
          if (masterFileList.length > 0) {
            formHeader.CTRUser = userInfo.id;
            formHeader.PerformanceBondHeader =
              financialInfo?.PerformanceBond || "";
            formHeader.PerformanceBondItem =
              objChangeMasterFile?.RequestFormItem.PerformanceBondItem || "";
            formHeader.Remark =
              objChangeMasterFile?.RequestFormItem.Remark || "";
            formHeader.AccountId =
              accountMenu.accountFinancialInfo[0].AccountId || "";
            formHeader.FinancialInformationId =
              accountMenu.accountFinancialInfo[0].Id || "";

            let resPerfomance = await PerformanceBondAPI.submitRequestForm(
              formHeader
            );
            console.log("response create perfomance bond :: ", resPerfomance);
            setFormId(resPerfomance && resPerfomance.RegistrationNumber);

            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }

      // Clear input values
      return true;
    } catch (error) {
      console.error("Error in handling file upload:", error);
      return false;
    }
  };

  const checkFilesExist = async () => {
    const fileInputs = [{ id: "FileOther2", label: "FileOther2" }];
    let filesExist = [];
    fileInputs.forEach((input) => {
      const fileInputElement = document.getElementById(input.id);
      if (fileInputElement.files.length > 0) {
        Array.from(fileInputElement.files).forEach((file) =>
          filesExist.push(file.name)
        );
      }
    });

    return filesExist.length > 0;
  };

  const handleSubmitFiles = async function () {
    try {
      setLoading(true);
      const result = await Swal.fire({
        title: "Are you sure you want to save?",
        icon: "question",
        position: "center",
        showDenyButton: true,
        confirmButtonText: "Yes",
        denyButtonText: "Cancel",
        cancelButtonColor: "red",
      });

      if (result.isConfirmed) {
        let resChecks = await updateFiles(); // อัพโหลดไฟล์ไปยัง SharePoint and create performance bond

        if (resChecks) {
          // if (formItems) {
          //   await Swal.fire({
          //     title: resChecks ? "Update Complete" : "Update Fail",
          //     icon: resChecks ? "success" : "error",
          //     showConfirmButton: true,
          //   });
          //   if (resChecks) {
          //     navigate("/main"); // ถ้าอัพโหลดสำเร็จไปหน้า Home
          //   }
          // } else {
          setOpenModalComplete(true);
          // }
          document
            .getElementById("check-form-data-register-save-draft")
            .click();
          // setSelectedOther([]);
        } else {
          setOpenModalComplete(false);
        }

        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error in handling form submission:", error);
    }
  };

  const renderRequirmentScreen = (edit) => {
    return (
      <RequiredUploadDocuments
        isEdited={edit}
        objChangeMasterFile={objChangeMasterFile}
        financialInfo={financialInfo}
        setObjChangeMasterFile={setObjChangeMasterFile}
        setSelectedOther={setSelectedOther}
        selectedOther={selectedOther}
        setLoading={() => setLoading(false)}
        formView={formItems}
        formDisabled={disalbedForm}
        defaultPerformanceBond={defaultPerformanceBond}
      />
    );
  };

  return (
    <Container
      maxWidth="xl"
      className="RequestViewScreen"
      sx={{ margin: 5, border: "none" }}
    >
      {/* request number and date */}
      {!disalbedForm && (
        <div className="header">
          <div>
            <label>Request Number</label>
            <p>{formItems?.Name || "-"}</p>
          </div>
          <div>
            <label>Last Update Date</label>
            <p>
              {(formItems &&
                dayjs(formItems.LastModifiedDate).format("DD/MM/YYYY HH:mm")) ||
                "-"}
            </p>
          </div>
        </div>
      )}

      {/* status */}
      <div className="path">
        <ApprovalStatus
          currentStatus={(location && location.state?.status) || ""}
        />
      </div>

      {/* main */}
      <div style={{ display: "flex", marginTop: "10px" }}>
        {/* sidebar */}
        <div className="sidebar">
          <nav className="slds-nav-vertical" aria-label="Sub page">
            <div className="slds-nav-vertical__section">
              <ul aria-describedby="entity-header">
                <li
                  className={"slds-nav-vertical__item slds-is-active"}
                  data-tab="RegistrationForm"
                >
                  <span className="slds-nav-vertical__action">
                    Request Detail
                  </span>
                </li>
              </ul>
            </div>
          </nav>
        </div>

        {/* body */}
        <Stack sx={{ width: "100%" }} spacing={2}>
          <Box sx={{ margin: 10 }}>{renderRequirmentScreen(isEdited)}</Box>
        </Stack>
      </div>

      {/* button-upload-submit */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        {/* loading */}
        {loading && (
          <Backdrop sx={{ color: "#fff", zIndex: 2 }} open={true}>
            <span
              style={{
                justifyContent: "center",
                position: "fixed",
                top: "40%",
              }}
            >
              <Box
                sx={{
                  p: 2,
                  m: 2,
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <CircularProgress
                  style={{
                    width: 100,
                    height: 100,
                    color: "rgba(184,0,200,1)",
                  }}
                />
              </Box>
              <Box sx={{ justifyContent: "center", display: "flex" }}>
                <label style={{ fontSize: 22, fontWeight: "bold" }}>
                  {" "}
                  Please wait...
                </label>
              </Box>
            </span>
          </Backdrop>
        )}

        {disalbedForm && !loading && (
          <div style={{ margin: 20 }}>
            {/* cancel */}
            <Button
              sx={{ p: 1, m: 1 }}
              variant="outlined"
              onClick={() => {
                Swal.fire({
                  title: "Do you want to leave this page?",
                  icon: "question",
                  position: "center",
                  showDenyButton: true,
                  showCancelButton: false,
                  confirmButtonText: "Yes",
                }).then((result) => {
                  if (result.isConfirmed) {
                    navigate("/main");
                  }
                });
              }}
              style={{
                backgroundColor: "#fff",
                color: "#757575",
                borderColor: "gray",
              }}
            >
              Cancel
            </Button>
            {/* submit */}
            <Button
              sx={{ p: 1, m: 1 }}
              variant="contained"
              disabled={loading}
              onClick={() => {
                handleSubmitFiles();
              }}
              style={{ backgroundColor: "#2C88D9", color: "white" }}
            >
              <label
                style={{ paddingLeft: 4, paddingRight: 4, cursor: "pointer" }}
              >
                Submit
              </label>
            </Button>
          </div>
        )}
      </Box>

      <ModalPerformanceBondForm
        fromId={formItems ? formItems?.Name : formId}
        open={openModalComplete}
      />
    </Container>
  );
}
